import React from 'react';
import { TrialInputProps } from '~/common/types';
import { Input } from '~/common/components/Input';
import { validateString, validateEmail, validateFullName } from '~/common/util/customValidation';
import { Field } from 'formik';
import styles from '../Grid.module.css';
import { trackBlur } from '~/common/util/trackBlur';

export const BusinessBuyInput = (props: TrialInputProps) => {
  const {
    formikTouched,
    formikErrors,
    inputs,
    showHint,
    trackErrorBlur,
    validateBusinessEmail,
    existingAccount,
    userEmail,
    existingEmailError,
  } = props;

  const { fullName, email, company } = inputs;

  return (
    <div className={`${styles.inputGrid} ${styles.trial}`}>
      {fullName && (
        <Field
          name={fullName.id}
          type={'text'}
          error={formikErrors[fullName.id] && formikTouched[fullName.id]}
          errormessage={fullName.error}
          validate={validateFullName}
          as={Input}
          label={fullName.label}
          onFocus={() => {
            trackBlur(fullName.id);
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            trackErrorBlur(fullName.id, validateFullName, event.target.value);
          }}
          autoFocus={true}
        />
      )}
      {!userEmail ? (
        <Field
          name={email.id}
          type={'email'}
          error={formikErrors[email.id] && formikTouched[email.id]}
          errormessage={existingAccount ? existingEmailError : email.error}
          showHint={showHint}
          hintmessage={email.placeHolder}
          validate={validateEmail}
          as={Input}
          label={email.label}
          maxLength={128}
          onFocus={() => {
            trackBlur(email.id);
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            validateBusinessEmail(event.target.value);
            trackErrorBlur(email.id, validateEmail, event.target.value);
          }}
        />
      ) : (
        <div></div>
      )}
      {company && (
        <Field
          name={company.id}
          type={'text'}
          error={formikErrors[company.id] && formikTouched[company.id]}
          errormessage={company.error}
          validate={validateString}
          as={Input}
          label={company.label}
          onFocus={() => {
            trackBlur(company.id);
          }}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            trackErrorBlur(company.id, validateString, event.target.value);
          }}
        />
      )}
    </div>
  );
};
